import React from 'react';
import { Poppins } from 'src/common';
import { Chip } from 'src/components/FiltersSlider/comps';
import { ChipContents } from 'src/components/FiltersSlider/styled';
import styled from 'styled-components';
import { useFiltersState, FiltersType, ModalType } from './state';
import _ from 'lodash';

const Div = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
`;

interface FilterData {
  labels: string[];
  shouldShow: boolean;
  count: number;
}

const getFilterData = (filterArray: FiltersType[ModalType]): FilterData => {
  const enabledItems = _.filter(filterArray, (el) => el?.enabled);
  const labels = enabledItems
    .map((el) => el?.label)
    .sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }));

  const shouldShow = enabledItems.length > 0 && enabledItems.length < filterArray.length;

  return {
    labels,
    shouldShow,
    count: enabledItems.length,
  };
};

export const Indicators: React.FC = () => {
  const { filters, setFilters } = useFiltersState();

  const assessmentsData = getFilterData(filters.assessments);
  const strategyData = getFilterData(filters.strategy);
  const statusData = getFilterData(filters.status);
  const ownersData = getFilterData(filters.owners);
  const frameworksData = getFilterData(filters.frameworks);
  const existingMaturityData = getFilterData(filters.existingMaturity);
  const targetMaturityData = getFilterData(filters.targetMaturity);

  const handleClear = (filterKey: ModalType) => {
    setFilters({
      ...filters,
      [filterKey]: filters[filterKey].map((item) => ({ ...item, enabled: true })),
    });
  };

  return (
    <Div>
      {assessmentsData.shouldShow && (
        <Chip
          title="Assessments"
          selected={assessmentsData.count}
          onClear={() => handleClear('assessments')}
          white
          popupContents={
            <ChipContents>
              <Poppins px={14} weight={500} color="cflowerBlue" className="ip-title">
                ASSESSMENTS
              </Poppins>
              {assessmentsData.labels.map((el) => (
                <Poppins key={el} px={14} weight={500} color="davysGrey" nowrap>
                  {el}
                </Poppins>
              ))}
            </ChipContents>
          }
        />
      )}

      {strategyData.shouldShow && (
        <Chip
          title="Strategy"
          selected={strategyData.count}
          onClear={() => handleClear('strategy')}
          white
          popupContents={
            <ChipContents>
              <Poppins px={14} weight={500} color="cflowerBlue" className="ip-title">
                STRATEGY
              </Poppins>
              {strategyData.labels.map((el) => (
                <Poppins key={el} px={14} weight={500} color="davysGrey" nowrap>
                  {el}
                </Poppins>
              ))}
            </ChipContents>
          }
        />
      )}

      {statusData.shouldShow && (
        <Chip
          title="Status"
          selected={statusData.count}
          onClear={() => handleClear('status')}
          white
          popupContents={
            <ChipContents>
              <Poppins px={14} weight={500} color="cflowerBlue" className="ip-title">
                STATUS
              </Poppins>
              {statusData.labels.map((el) => (
                <Poppins key={el} px={14} weight={500} color="davysGrey" nowrap>
                  {el}
                </Poppins>
              ))}
            </ChipContents>
          }
        />
      )}

      {ownersData.shouldShow && (
        <Chip
          title="Owner"
          selected={ownersData.count}
          onClear={() => handleClear('owners')}
          white
          popupContents={
            <ChipContents>
              <Poppins px={14} weight={500} color="cflowerBlue" className="ip-title">
                OWNERS
              </Poppins>
              {ownersData.labels.map((el) => (
                <Poppins key={el} px={14} weight={500} color="davysGrey" nowrap>
                  {el}
                </Poppins>
              ))}
            </ChipContents>
          }
        />
      )}

      {frameworksData.shouldShow && (
        <Chip
          title="Framework"
          selected={frameworksData.count}
          onClear={() => handleClear('frameworks')}
          white
          popupContents={
            <ChipContents>
              <Poppins px={14} weight={500} color="cflowerBlue" className="ip-title">
                FRAMEWORKS
              </Poppins>
              {frameworksData.labels.map((el) => (
                <Poppins key={el} px={14} weight={500} color="davysGrey" nowrap>
                  {el}
                </Poppins>
              ))}
            </ChipContents>
          }
        />
      )}

      {existingMaturityData.shouldShow && (
        <Chip
          title="Existing Maturity"
          selected={existingMaturityData.count}
          onClear={() => handleClear('existingMaturity')}
          white
          popupContents={
            <ChipContents>
              <Poppins px={14} weight={500} color="cflowerBlue" className="ip-title">
                EXISTING MATURITY
              </Poppins>
              {existingMaturityData.labels.map((el) => (
                <Poppins key={el} px={14} weight={500} color="davysGrey" nowrap>
                  {el}
                </Poppins>
              ))}
            </ChipContents>
          }
        />
      )}

      {targetMaturityData.shouldShow && (
        <Chip
          title="Target Maturity"
          selected={targetMaturityData.count}
          onClear={() => handleClear('targetMaturity')}
          white
          popupContents={
            <ChipContents>
              <Poppins px={14} weight={500} color="cflowerBlue" className="ip-title">
                TARGET MATURITY
              </Poppins>
              {targetMaturityData.labels.map((el) => (
                <Poppins key={el} px={14} weight={500} color="davysGrey" nowrap>
                  {el}
                </Poppins>
              ))}
            </ChipContents>
          }
        />
      )}
    </Div>
  );
};
